/* Kahaus: klik w DOWOLNE miejsce karty (zdjęcie, tło) → strona produktu.
   Poza kontrolkami (kropki koloru, „do koszyka", formularze). Naprawia „tylko tytuł klikalny". */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('button, .kahaus-dot-btn, .kahaus-card-dots, .quick-add, product-form, modal-opener, quick-add-modal, input, select, textarea, label')) return;
    var card = t.closest('.product-card-wrapper, .card-wrapper');
    if (!card) return;
    var link = card.querySelector('a.kahaus-media-link[href], .card__heading a[href], a.full-unstyled-link[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    var clickedA = t.closest('a[href]');
    if (clickedA && clickedA.href === link.href) return; // właściwy link — zostaw natywnie
    e.preventDefault();
    window.location.href = link.href;
  });
})();

/* Kahaus: karta — klik kropki koloru przełącza WARIANT (zdjęcie główne + hover per-SKU + link). */
(function () {
  function cardOf(el) { return el.closest('.card-wrapper') || el.closest('.card'); }
  function mediaImgs(card) { return card ? card.querySelectorAll('.card__media .media img') : []; }
  function applyDot(btn) {
    var card = cardOf(btn); if (!card) return;
    var imgs = mediaImgs(card), main = imgs[0], sec = imgs[1];
    if (main && btn.dataset.kahausImg) { main.removeAttribute('srcset'); main.src = btn.dataset.kahausImg; }
    if (sec && btn.dataset.kahausImg1) { sec.removeAttribute('srcset'); sec.src = btn.dataset.kahausImg1; }
    if (btn.dataset.kahausUrl) {
      card.querySelectorAll('a.kahaus-media-link, .card__heading a, a.card__link, a.full-unstyled-link').forEach(function (a) { a.href = btn.dataset.kahausUrl; });
    }
    var dots = btn.closest('.kahaus-card-dots');
    if (dots) dots.querySelectorAll('.kahaus-dot-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.kahaus-dot-btn');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    applyDot(btn);
  });
  // init: hover per-SKU = 2. zdjęcie AKTYWNEGO koloru (a nie innego wariantu/rodziny)
  function kahausDotsInit() {
    document.querySelectorAll('.kahaus-card-dots').forEach(function (dots) {
      var btn = dots.querySelector('.kahaus-dot-btn.is-active') || dots.querySelector('.kahaus-dot-btn');
      var card = cardOf(dots);
      if (!btn || !card) return;
      var sec = mediaImgs(card)[1];
      if (sec && btn.dataset.kahausImg1) { sec.removeAttribute('srcset'); sec.src = btn.dataset.kahausImg1; }
    });
  }
  if (document.readyState !== 'loading') kahausDotsInit(); else document.addEventListener('DOMContentLoaded', kahausDotsInit);
})();

/* Kahaus: wybór języka dostosowuje kraj/walutę.
   Mapa język -> kraj; PL->PLN, RO->RON, HU->HUF, reszta strefa euro (EN->IE).
   Doklejamy country_code do formularza języka (capture — przed submitem Dawn),
   więc Shopify przełącza język I walutę jednym żądaniem. */
(function () {
  var LANG_COUNTRY = { pl: 'PL', en: 'IE', de: 'DE', fr: 'FR', it: 'IT', es: 'ES', nl: 'NL', ro: 'RO', hu: 'HU', sk: 'SK' };
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest && e.target.closest('.kahaus-loc-language .disclosure__link[data-value]');
      if (!link) return;
      var iso = (link.dataset.value || '').toLowerCase();
      var country = LANG_COUNTRY[iso];
      var form = link.closest('form');
      if (!country || !form) return;
      // przejmujemy submit: ustawiamy język I kraj razem, potem sami wysyłamy
      e.preventDefault();
      e.stopPropagation();
      var lc = form.querySelector('input[name="locale_code"]');
      if (lc) lc.value = iso;
      var cc = form.querySelector('input[name="country_code"]');
      if (!cc) {
        cc = document.createElement('input');
        cc.type = 'hidden';
        cc.name = 'country_code';
        form.appendChild(cc);
      }
      cc.value = country;
      HTMLFormElement.prototype.submit.call(form);
    },
    true
  );
})();

/* Kahaus PDP v0.3.0: mirror ceny do CTA + sticky „do koszyka" (mobile) + kompaktowy header na scroll */
(function () {
  // -- mirror aktualnej ceny do przycisków „do koszyka" i paska sticky --
  function currentPrice() {
    var box = document.querySelector('[id^="price-"]');
    if (!box) return '';
    var onSale = box.classList.contains('price--on-sale') || (box.closest && box.closest('.price--on-sale'));
    var el =
      (onSale && box.querySelector('.price-item--sale')) ||
      box.querySelector('.price-item--regular') ||
      box.querySelector('.price-item');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function mirrorPrice() {
    var val = currentPrice();
    if (!val) return;
    var nodes = document.querySelectorAll('[data-kahaus-atc-price]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = (nodes[i].hasAttribute('data-price-dash') ? '— ' : '') + val;
    }
  }
  var priceBox = document.querySelector('[id^="price-"]');
  if (priceBox && 'MutationObserver' in window) {
    new MutationObserver(mirrorPrice).observe(priceBox, { childList: true, subtree: true, characterData: true });
  }
  mirrorPrice();

  // -- przyklejony pasek „do koszyka" na mobile --
  var sticky = document.querySelector('.kahaus-sticky-atc[data-kahaus-sticky]');
  if (sticky) {
    var realBtn = document.getElementById(sticky.getAttribute('data-atc-target'));
    var stickyBtn = sticky.querySelector('[data-kahaus-sticky-add]');
    if (realBtn && stickyBtn) {
      stickyBtn.addEventListener('click', function () { realBtn.click(); });
    }
    var anchor = realBtn || document.querySelector('.product__info-container');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            sticky.classList.toggle('is-visible', !entries[i].isIntersecting);
          }
        },
        { rootMargin: '0px 0px -20px 0px' }
      ).observe(anchor);
    }
  }

  // -- kompaktowy header po przewinięciu w dół --
  var wrap = document.querySelector('sticky-header.header-wrapper') || document.querySelector('.header-wrapper');
  if (wrap) {
    var ticking = false;
    function updHeader() {
      ticking = false;
      wrap.classList.toggle('kahaus-header-compact', (window.scrollY || window.pageYOffset || 0) > 60);
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          (window.requestAnimationFrame || window.setTimeout)(updHeader);
        }
      },
      { passive: true }
    );
    updHeader();
  }
})();

/* Kahaus: hero rotator (losowe produkty z różnych rodzin) + quick-add „+" */
(function () {
  var rot = document.querySelector('[data-kahaus-hero-rotator]');
  if (!rot) return;
  var box = rot.querySelector('.kahaus-hero__slides');
  var all = Array.prototype.slice.call(rot.querySelectorAll('.kahaus-hero__slide'));
  if (!box || !all.length) return;

  var count = Math.max(1, parseInt(rot.getAttribute('data-count'), 10) || 5);
  var interval = Math.max(2000, parseInt(rot.getAttribute('data-interval'), 10) || 4500);

  var pool = all.slice();
  for (var i = pool.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var t = pool[i]; pool[i] = pool[j]; pool[j] = t;
  }
  var chosen = [], seen = {};
  pool.forEach(function (s) {
    if (chosen.length >= count) return;
    var f = s.getAttribute('data-family') || '';
    if (!seen[f]) { seen[f] = 1; chosen.push(s); }
  });
  if (chosen.length < count) {
    pool.forEach(function (s) { if (chosen.length < count && chosen.indexOf(s) === -1) chosen.push(s); });
  }
  all.forEach(function (s) { s.classList.remove('is-active'); });
  chosen.forEach(function (s) { box.appendChild(s); });

  var dotsWrap = rot.querySelector('[data-hero-dots]');
  var dots = [];
  if (dotsWrap) {
    dotsWrap.innerHTML = '';
    chosen.forEach(function (_, k) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kahaus-hero__dot';
      b.setAttribute('aria-label', 'Produkt ' + (k + 1));
      b.addEventListener('click', function () { go(k); });
      dotsWrap.appendChild(b); dots.push(b);
    });
  }

  var idx = 0, timer = null;
  function paint() {
    chosen.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
  }
  function go(k) { idx = (k + chosen.length) % chosen.length; paint(); restart(); }
  function restart() { if (timer) clearInterval(timer); if (chosen.length > 1) timer = setInterval(function () { go(idx + 1); }, interval); }
  paint(); restart();
  rot.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
  rot.addEventListener('mouseleave', restart);

  rot.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.kahaus-hero__add');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant');
    if (!id || btn.classList.contains('is-loading')) return;
    var span = btn.querySelector('span'), orig = span ? span.textContent : '+';
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var wantsDrawer = drawer && typeof drawer.renderContents === 'function';
    var body = { items: [{ id: id, quantity: 1 }], sections_url: window.location.pathname };
    body.sections = wantsDrawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-loading'); btn.classList.add('is-added');
      if (span) span.textContent = '✓';
      setTimeout(function () { btn.classList.remove('is-added'); if (span) span.textContent = orig; }, 1600);
      if (res && res.sections) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections['cart-icon-bubble']) bubble.innerHTML = res.sections['cart-icon-bubble'];
        if (wantsDrawer && res.sections['cart-drawer']) {
          drawer.classList.remove('is-empty');
          try { drawer.renderContents(res); } catch (err) {}
        }
      }
    }).catch(function () { btn.classList.remove('is-loading'); if (span) span.textContent = orig; });
  });
})();


/* ===== Auto-przełączanie rozmiaru gdy wybrany kolor niedostępny w bieżącym rozmiarze (i18n toast) =====
   Capture-phase: korygujemy checked rozmiaru ZANIM variant-selects Dawn odczyta formularz -> 1 fetch, bez migotania. */
(function () {
  var SIZE_RE = /size|rozmiar|gr(ö|o)sse|taille|maat|talla|taglia/i;
  var COLOR_RE = /colou?r|kolor|farbe|couleur|kleur|colore/i;
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\\]]/g, '\\$&'); }
  var toastEl;
  function toast(msg) {
    if (!msg) return;
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'kahaus-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 4500);
  }
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
    if (!COLOR_RE.test(input.getAttribute('data-option-name') || '')) return;
    var vs = input.closest('variant-selects'); if (!vs) return;
    var mEl = vs.querySelector('[data-kahaus-variants]'); if (!mEl) return;
    var data; try { data = JSON.parse(mEl.textContent); } catch (_) { return; }
    var names = data.optionNames || [], variants = data.variants || [];
    var si = -1, ci = -1;
    for (var i = 0; i < names.length; i++) { if (si < 0 && SIZE_RE.test(names[i])) si = i; if (ci < 0 && COLOR_RE.test(names[i])) ci = i; }
    if (si < 0 || ci < 0) return; // tylko produkty z OBIEMA opcjami
    var color = input.value, sizeName = names[si];
    var sizeRadio = vs.querySelector('input[type="radio"][data-option-name="' + cssEsc(sizeName) + '"]:checked');
    if (!sizeRadio) return;
    var isAvail = false, newSize = null;
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      if (v.values[ci] === color) {
        if (v.values[si] === sizeRadio.value && v.available) { isAvail = true; break; }
        if (newSize === null && v.available) newSize = v.values[si];
      }
    }
    if (isAvail || !newSize || newSize === sizeRadio.value) return;
    var newRadio = vs.querySelector('input[type="radio"][data-option-name="' + cssEsc(sizeName) + '"][value="' + cssEsc(newSize) + '"]');
    if (!newRadio) return;
    newRadio.checked = true; // synchronicznie, przed handlerem Dawn (bubble)
    var tpl = mEl.getAttribute('data-switch-msg') || '';
    toast(tpl.replace('%COLOR%', color).replace('%SIZE%', newSize));
  }, true); // capture

  // === Kahaus ticker: „ile wydrukowaliśmy, odkąd tu jesteś" ===
  // Startuje od ZERA przy wejściu na stronę — świadomie, bo historycznego baseline'u
  // nie mamy i nie zamierzamy go zmyślać. Tempo (data-rate) = minuty druku na minutę
  // zegara, zmierzone ze sprzedaży. Licznik jest więc prawdziwy w każdej sekundzie.
  // Tyka 1×/s (nie 60×/s) — zero kosztu dla baterii.
  if (window.customElements && !customElements.get('kahaus-ticker')) {
    customElements.define('kahaus-ticker', class extends HTMLElement {
      connectedCallback() {
        var rate = parseFloat(this.getAttribute('data-rate'));
        if (!isFinite(rate) || rate <= 0) return; // brak tempa = licznik zostaje na „0"
        this.sep = this.getAttribute('data-sep') || ',';
        this.unit = this.getAttribute('data-unit') || '';
        this.perSec = rate / 60;
        this.t0 = Date.now();
        // WCAG 2.2.2 — ruchoma treść musi dać się zatrzymać. Przy reduced-motion
        // pokazujemy statyczny wynik po minucie zamiast animacji.
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) { this.render(rate); return; }
        var self = this;
        this.tick = function () { self.render((Date.now() - self.t0) / 1000 * self.perSec); };
        this.tick();
        this.timer = setInterval(this.tick, 1000);
        // Karta w tle = licznik i tak przeliczy się z zegara przy powrocie; nie mielimy w tle.
        this._vis = function () {
          if (document.hidden) { clearInterval(self.timer); self.timer = null; }
          else if (!self.timer) { self.tick(); self.timer = setInterval(self.tick, 1000); }
        };
        document.addEventListener('visibilitychange', this._vis);
      }
      render(v) {
        // Poniżej 100 pokazujemy 1 miejsce po przecinku — inaczej gramy (4,16/min) stałyby
        // w miejscu przez ~14 s i licznik wyglądałby na zepsuty. Powyżej 100 ułamek to szum.
        var s = v < 100 ? v.toFixed(1).replace('.', this.sep) : String(Math.floor(v));
        this.textContent = this.unit ? s + ' ' + this.unit : s;
      }
      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
        if (this._vis) document.removeEventListener('visibilitychange', this._vis);
      }
    });
  }

  // === Kahaus per-variant gallery: cała galeria przełącza się pod SKU ===
  // Dane z metapola custom.gallery (list.url z BaseLinkera), hook = input[name="id"] change.
  if (window.customElements && !customElements.get('kahaus-gallery')) {
    customElements.define('kahaus-gallery', class extends HTMLElement {
      connectedCallback() {
        try { this.map = JSON.parse(this.querySelector('[data-kg-map]').textContent); } catch (_) { this.map = {}; }
        this.mainWrap = this.querySelector('[data-kg-main]');
        this.thumbsEl = this.querySelector('[data-kg-thumbs]');
        this.current = this.getAttribute('data-current-variant');
        this.urls = this.map[this.current] || [];
        var self = this;
        if (this.thumbsEl) {
          this.thumbsEl.addEventListener('click', function (e) {
            var b = e.target && e.target.closest ? e.target.closest('[data-kg-idx]') : null;
            if (b) self.activate(parseInt(b.getAttribute('data-kg-idx'), 10));
          });
        }
        this._onChange = function (e) {
          var t = e.target;
          if (t && t.matches && t.matches('input[name="id"]')) self.setVariant(t.value);
        };
        document.addEventListener('change', this._onChange, true);
      }
      disconnectedCallback() { document.removeEventListener('change', this._onChange, true); }
      setVariant(vid) {
        if (!vid || vid === this.current) return;
        var urls = this.map[vid];
        if (!urls || !urls.length) return;
        this.current = vid; this.urls = urls;
        this.setAttribute('data-current-variant', vid);
        if (this.thumbsEl) {
          var html = '';
          for (var i = 0; i < urls.length; i++) {
            html += '<li><button type="button" class="kahaus-gallery__thumb' + (i === 0 ? ' is-active' : '') +
              '" data-kg-idx="' + i + '" aria-label="' + (i + 1) + '"><img src="' + urls[i] +
              '" alt="" loading="lazy" width="140" height="140"></button></li>';
          }
          this.thumbsEl.innerHTML = html;
          this.thumbsEl.style.display = urls.length > 1 ? '' : 'none';
        }
        this.setMain(urls[0]);
      }
      activate(i) {
        if (!this.urls) this.urls = this.map[this.current] || [];
        var u = this.urls[i]; if (!u) return;
        this.setMain(u);
        if (this.thumbsEl) {
          var btns = this.thumbsEl.querySelectorAll('.kahaus-gallery__thumb');
          for (var b = 0; b < btns.length; b++) btns[b].classList.toggle('is-active', b === i);
        }
      }
      setMain(u) {
        if (!this.mainWrap) return;
        var img = this.mainWrap.querySelector('[data-kg-main-img]');
        if (!img) { img = document.createElement('img'); img.setAttribute('data-kg-main-img', ''); img.width = 1200; img.height = 1200; this.mainWrap.appendChild(img); }
        img.src = u;
      }
    });
  }
})();

/* Kahaus mobile: kropki pozycji dla przesuwanego pasa zdjęć w karcie (swipe lewo/prawo). */
(function () {
  function build(strip) {
    if (strip._kahausDots) return;
    var slides = strip.querySelectorAll('.kahaus-mswipe__slide');
    if (slides.length < 2) return;
    strip._kahausDots = true;
    var dots = document.createElement('div');
    dots.className = 'kahaus-mswipe__dots';
    for (var i = 0; i < slides.length; i++) {
      var d = document.createElement('span');
      d.className = 'kahaus-mswipe__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    }
    // overlay kropek trzymamy w .card__media (poza scrollującym pasem), żeby nie jeździły ze zdjęciami
    var host = strip.parentNode || strip;
    host.appendChild(dots);
    // strzałki lewo/prawo — klik zmienia zdjęcie (pętla na końcach); pomarańczowe, klimat KRAFT
    function makeArrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kahaus-mswipe__arrow kahaus-mswipe__arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0 ? 'Poprzednie zdjęcie' : 'Następne zdjęcie');
      b.innerHTML = dir < 0
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="square"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="square"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var w = strip.clientWidth || 1;
        var n = slides.length;
        var cur = Math.round(strip.scrollLeft / w);
        var to = (cur + (dir < 0 ? -1 : 1) + n) % n;
        if (strip.scrollTo) strip.scrollTo({ left: to * w, behavior: 'smooth' });
        else strip.scrollLeft = to * w;
      });
      return b;
    }
    host.appendChild(makeArrow(-1));
    host.appendChild(makeArrow(1));
    var ticking = false;
    strip.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        ticking = false;
        var w = strip.clientWidth || 1;
        var idx = Math.round(strip.scrollLeft / w);
        var ds = dots.children;
        for (var k = 0; k < ds.length; k++) ds[k].classList.toggle('is-active', k === idx);
      });
    }, { passive: true });
  }
  function init() {
    if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('[data-kahaus-mswipe]').forEach(build);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Kahaus: reveal na scroll wg POŁOŻENIA — hero/USP/kafelki kategorii ORAZ karty produktów.
   Karty przejmujemy od Dawn (zdejmujemy jego jednolity zjazd), żeby też wjeżdżały wg położenia.
   Lewa→z lewej, prawa→z prawej, środek→z dołu; mobile→z dołu (bez poziomego scrolla). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.kahaus-kchip, .kahaus-usp__tile, .kahaus-hero__content, .kahaus-hero__media, .kahaus-hero__stamp, .product-grid > .grid__item';
  var DAWN = ['scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen', 'scroll-trigger--visible'];
  var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('kv-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.02 });
  function strip(n) { DAWN.forEach(function (c) { n.classList.remove(c); }); }
  function groupOf(el) { return el.closest('ul.product-grid, .kahaus-kchips, .kahaus-usp__grid, .kahaus-hero__grid') || el.parentNode; }
  function run() {
    // przejmij karty od Dawn: zdejmij scroll-trigger z siatek, ich owijek i pojedynczych kart
    [].slice.call(document.querySelectorAll('.product-grid, .product-grid > .grid__item')).forEach(strip);
    [].slice.call(document.querySelectorAll('slider-component')).forEach(function (sc) { if (sc.querySelector('.product-grid')) strip(sc); });
    var counts = (typeof Map === 'function') ? new Map() : null;
    [].slice.call(document.querySelectorAll(SEL)).forEach(function (el) {
      if (el.hasAttribute('data-kv')) return;
      if (el.classList.contains('scroll-trigger') || el.closest('.scroll-trigger')) return;
      var r = el.getBoundingClientRect();
      if (!r.width) return;
      var cx = (r.left + r.width / 2) / (window.innerWidth || 1);
      var x = 0, y = 0;
      if (mobile) { y = 24; } else if (cx < 0.4) { x = -34; } else if (cx > 0.6) { x = 34; } else { y = 28; }
      el.style.setProperty('--kvx', x + 'px');
      el.style.setProperty('--kvy', y + 'px');
      var g = groupOf(el);
      var c = counts ? (counts.get(g) || 0) : 0;
      el.style.setProperty('--kvd', Math.min(c * 55, 350) + 'ms');
      if (counts) counts.set(g, c + 1);
      el.setAttribute('data-kv', '');
      io.observe(el);
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  // bezpiecznik: po 3.5s pokaż wszystko, co jeszcze nie weszło (gdyby observer coś pominął)
  setTimeout(function () {
    document.querySelectorAll('[data-kv]:not(.kv-in)').forEach(function (el) { el.classList.add('kv-in'); });
  }, 3500);
})();
